export default __webpack_public_path__ + "static/media/VISITE LIBRE.63efac85.svg";